import React from 'react'
import SEO from '../../components/SEO'
import { Helmet } from 'react-helmet-async'
import Navbar from '../../components/Navbar'
import Footer from '../../components/Footer'
import AboutHero from './components/aboutHero/AboutHero'
import WhoWeAre from './components/who/WhoWeAre'
import OurStory from './components/story/OurStory'
import Approach from './components/approach/Approach'
import CoreValues from './components/values/CoreValues'
import { structuredData } from '../../data/structuredData'

function About() {
  return (
    <>
      <SEO
        title='About Us'
        description='RaStegHub is a tech innovation hub in Nairobi building software, SaaS products, and digital solutions for businesses across Africa.'
        url='/about'
      />
      <Helmet>
        <script type='application/ld+json'>{JSON.stringify(structuredData)}</script>
      </Helmet>
      <div>
        <Navbar />
        <AboutHero />
        <WhoWeAre />
        <OurStory />
        <CoreValues />
        <Approach />
        <Footer />
        {/* <Chatbot /> */}
      </div>
    </>
  )
}

export default About